<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a tooltip to display some help text
    *
    * @since 20200414
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2020 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <span v-if="iconText.length > 0" :id="span_id" :class="['rounded-circle float-left m-1 small text-white text-center align-middle', type]" style="width:30px;height:30px;display: flex;align-content: center;justify-content: center;flex-direction: column;" aria-hidden="true" data-toggle="popover" data-placement="top" data-trigger="hover" data-html="true" :data-content="text" @mouseover="on_hover">{{iconText}}</span>
    <span v-else :id="span_id" :class="['fa', icon, 'fa-lg', type]" aria-hidden="true" data-toggle="popover" data-placement="top" data-trigger="hover" data-html="true" :data-content="text" @mouseover="on_hover"></span>
</template>

<script>
    //stores a counter of ids so that each tooltip has a unique id for reference
    export const store = {
        state: 1,
        increment() {
            ++this.state
        }
    };
    export default{
        props: {
            //the text to be displayed on the tooltip
            text: {
                type: String,
                default: ''
            },
            //the text color class
            type: {
                type: String,
                default: 'text-info'
            },
            //the text color class
            icon: {
                type: String,
                default: 'fa-info-circle'
            },
            //the text color class
            iconText: {
                type: String,
                default: ''
            },
        },
        mounted() {
            this.the_id = store.state;
            store.increment();
        },
        data() {
            return {
                // the unique id
                the_id: 1
            }
        },
        computed: {
            /**
             * the unique id of the tooltip for use in the span
             * @returns String the id of the tooltip
             */
            span_id: function(){
                return 'tool_tip_' + this.the_id;
            }
        },
        methods: {
            /**
             * sometimes the tooltip doesn't show in complex vues, so force it to show when hovered
             */
            on_hover: function(){
                $('#' + this.span_id).popover("show");
            },
        }
    }
</script>